const apiUrl = process.env.REACT_APP_API_URL || '/api';
const apiOrigin = apiUrl.startsWith('http') ? new URL(apiUrl).origin : '';

export function getMediaUrl(value) {
  if (!value || typeof value !== 'string') return '';
  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue === 'https' || trimmedValue === 'http') return '';
  if (/^(https?:\/\/|data:image\/|blob:)/i.test(trimmedValue)) return trimmedValue;
  if (trimmedValue.startsWith('//')) return `${window.location.protocol}${trimmedValue}`;
  if (trimmedValue.startsWith('/')) return `${apiOrigin}${trimmedValue}`;
  return apiOrigin ? `${apiOrigin}/${trimmedValue}` : `/${trimmedValue}`;
}

export default getMediaUrl;
